<template>
  <div>
    <vuex-breadcrumb></vuex-breadcrumb>
    <h1 id="jump-to-header">{{heading || "Update"}}</h1>
    <profile-update :id="id"/>
    <actor-role-index
      :filtering="actor_filter"
      :refresh="refresh"
      @refreshed="refreshed"
    >
    </actor-role-index>
  </div>
</template>

<script>
import VuexBreadcrumb from './VuexBreadcrumb.vue'
import ProfileUpdate from './ProfileUpdate.vue'
import ActorRoleIndex from './ActorRoleIndex.vue'

export default {
  components: {
    VuexBreadcrumb,
    ProfileUpdate,
    ActorRoleIndex
  },
  props: {
    id: {
      Type: String
    },
    heading: {
      Type: String
    }
  },
  data() {
    return {
      actor_filter: {
        profile_ids: this.id
      },
      refresh: false
    }
  },
  methods: {
    refreshed() {
      this.refresh = false
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>